import Store from '@/store/'
import { Model } from '@vuex-orm/core'
import { MerchantModel, CustomerModel } from '@/models/UserHierarchy'
import { buildUpdateModel, buildFetchForShop } from './model-builder'

export class UserModel extends Model {
  static entity = 'users'

  static nameSingular = 'User'
  static namePlural = 'Users'

  static types() {
    return {
      USER: UserModel,
      MERCHANT: MerchantModel,
      CUSTOMER: CustomerModel,
    }
  }

  static fields() {
    return {
      id: this.uid(),
      first_name: this.string('').nullable(),
      last_name: this.string('').nullable(),
      phone: this.attr(''),
      phone_normalized: this.number(0),
      street: this.string('').nullable(),
      zip: this.string('').nullable(),
      email: this.string('').nullable(),
      email_verified_at: this.string('').nullable(),
      token: this.string(''),
      is_merchant: this.boolean(true),
      is_super_admin: this.boolean(false),
      is_logged_in: this.boolean(false),
    }
  }

  static getCurrent() {
    return this.query()
      .where('token', (token) => !!token)
      .first()
  }

  static fetchForShop(options) {
    return buildFetchForShop(this, options)
  }

  static fetchCurrent() {
    return this.api().get('/me', {
      dataTransformer: (response) => {
        response.data.data.is_logged_in = true
        return response.data.data
      },
    })
  }

  static updateModel(id, fields) {
    return buildUpdateModel(this, id, fields)
  }

  static customerLogin({ email, password }) {
    return this.api().post(
      '/login',
      { email, password },
      {
        dataTransformer: (response) => {
          response.data.data.is_logged_in = true
          return response.data.data
        },
      }
    )
  }
  static customerSignup(signupData) {
    let shopId = Store.getters['shop/getShopId']

    let {
      first_name,
      last_name,
      email,
      phone,
      password,
      password_confirmation,
      payment_service,
      payment_handle,
    } = signupData
    return this.api().post(
      `/shops/${shopId}/signup`,
      {
        first_name,
        last_name,
        email,
        phone,
        password,
        password_confirmation,
        payment_service,
        payment_handle,
      },
      {
        dataTransformer: (response) => {
          response.data.data.is_logged_in = true
          return response.data.data
        },
      }
    )
  }

  static merchantLogin(shopId, { email, password }) {
    return this.api().post(
      `/shops/${shopId}/login`,
      { email, password },
      {
        dataTransformer: (response) => {
          response.data.data.is_logged_in = true
          return response.data.data
        },
      }
    )
  }

  static async logout() {
    const currentUser = this.getCurrent()
    if (!currentUser) return
    try {
      await this.api().get('/logout', { save: false })
    } catch (error) {
      if (error.response && error.response.status === 401) {
        return Promise.resolve('unauthenticated == loggedOut')
      } else {
        return Promise.reject(error)
      }
    } finally {
      if (currentUser.id) {
        this.delete(currentUser.id)
      }
    }
  }
}
export default UserModel
